import Select from '@rio-cloud/rio-uikit/Select';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { type CountryCode, countryCodes } from '#utils/country.util.ts';

const getCountryFlagEmoji = (countryCode: CountryCode) => {
    const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map(char => 127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
};

type CountryFlagEmojiProps = {
    code?: CountryCode;
};

const CountryFlagEmoji = ({ code }: CountryFlagEmojiProps) => {
    return <span role='img'>{code ? getCountryFlagEmoji(code) : '🏳'}</span>;
};

type CountryPickerProps = {
    value?: string;
    onChange?: (value?: string) => void;
    className?: string;
    id: string;
    disabled?: boolean;
};

export const CountryPicker = ({ value, onChange, className, id, disabled }: CountryPickerProps) => {
    const countryOptions = countryCodes.map(code => ({
        id: code,
        label: (
            <span className='display-flex gap-3 align-items-center'>
                <span>
                    <FormattedMessage id={`intl-msg:ordercom-cloud-frontend.country.${code}`} /> ({code})
                </span>
            </span>
        ),
        icon: <CountryFlagEmoji code={code} />,
        selected: value === code,
    }));

    return (
        <Select
            id={id}
            options={countryOptions}
            className={classNames('width-100pct', className)}
            useFilter
            onChange={result => onChange?.(result?.id)}
            showSelectedItemIcon
            disabled={disabled}
        />
    );
};
